import React from "react"
import styled from "styled-components"
import Container from "./forLayout/container"
import BackgroundImage from "gatsby-background-image"
import { useStaticQuery, graphql } from "gatsby"
import Button from "./button/button"
import CardGroup from "./card/cardgroup"

const SectionCategory = styled.p`
  color: #999;
`

const SectionTitle = styled.h2`
  font-family: "GFS Didot", serif;
  font-size: 4rem;
  line-height: 4rem;
  margin-bottom: 2rem;
`

const ImageWrapper = styled.div`
  position: relative;
  button {
    position: absolute;
    bottom: 1rem;
    left: 1rem;
  }
`

const SectionParagraph = styled.p`
  color: #dedede;
  a {
    text-decoration: underline;
    color: #fff;
  }
  a:hover {
    color: #fff;
  }
`

const Spacer = styled.div`
  padding: 1.5rem 0;
`

const FourthSection = () => {
  const FourthSectionData = useStaticQuery(
    graphql`
      {
        image: file(name: { eq: "nike-img" }) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        productImage: allPixabayPhoto(limit: 4) {
          edges {
            node {
              largeImageURL
            }
          }
        }
      }
    `
  )

  return (
    <Container>
      <SectionCategory>Essentials Shop</SectionCategory>
      <SectionTitle>Designed for your crazy dreams</SectionTitle>
      <Spacer />
      <ImageWrapper>
        <BackgroundImage
          style={{ minHeight: "50vh" }}
          fluid={FourthSectionData.image.childImageSharp.fluid}
          alt="Photo of sport-girls"
        >
          <Button>Shop Essentials</Button>
        </BackgroundImage>
      </ImageWrapper>
      <Spacer />
      <SectionParagraph>
        Picked by women, for women. The Essentials Shop lets you sort by your
        sport to find everything you’ll need to live your crazy dream.
      </SectionParagraph>
      <Spacer />
      <CardGroup productData={FourthSectionData.productImage.edges} />
    </Container>
  )
}

export default FourthSection
